import { useState, useCallback } from 'react';

const useConfirmation = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [config, setConfig] = useState({
        title: '',
        message: '',
        confirmText: '',
        cancelText: '',
        onConfirm: () => {},
        onCancel: () => {},
        onClose: undefined,
    });

    const showConfirmation = useCallback((options) => {
        setConfig({
            title: options.title || '',
            message: options.message || '',
            confirmText: options.confirmText || '',
            cancelText: options.cancelText || '',
            onConfirm: options.onConfirm || (() => {}),
            onCancel: options.onCancel || (() => {}),
            onClose: options.onClose || (() => {}),
        });
        setIsOpen(true);
    }, []);

    const handleConfirm = useCallback(() => {
        config.onConfirm();
        setIsOpen(false);
    }, [config]);

    const handleCancel = useCallback(() => {
        config.onCancel();
        setIsOpen(false);
    }, [config]);

    const handleClose = useCallback(() => {
        if (config.onClose) {
            config.onClose();
        }
        setIsOpen(false);
    }, [config]);

    return {
        isOpen,
        title: config.title,
        message: config.message,
        confirmText: config.confirmText,
        cancelText: config.cancelText,
        showConfirmation,
        handleConfirm,
        handleCancel,
        handleClose,
    };
};

export default useConfirmation;